<template>
  <div id="app">
    <top></top>
    <!-- 路由占位符 -->
    <router-view :key="$route.fullPath"
      :style="{'--theme-color': themeColor,
      '--theme-bgcolor': themeBgColor,
      '--style-color': styleColor,
      '--style-bgcolor': styleBgColor,
      '--hoverStyle-color': hoverStyle,
      '--hoverStyle-bgcolor': hoverStyleBgColor,
      backgroundColor: themeBgColor,
      '--backgroundImage': backgroundImage,
      '--cover': cover,
      '--nav-color': navColor,
      '--detail-bgcolor': detailBgcolor}" />
    <bottom></bottom>
  </div>
</template>
<script>
  import top from '@/components/top.vue'
  import bottom from '@/components/bottom.vue'
  export default {
    components: {
      top,
      bottom
    },
    name: 'app',
    data() {
      return {
        num: 0,
        themeColor: '',
        themeBgColor: '',
        styleColor: '',
        styleBgColor: '',
        hoverStyle: '',
        hoverStyleBgColor: '',
        themeColor: '',
        navColor: '',
        detailBgcolor: '',
        backgroundImage: '',
        cover: '',
      }
    },
    watch: {
      '$route': {
        handler(e) {
          let website_id = localStorage.getItem('website_id')
          if (website_id == e.query.website_id) return
          localStorage.setItem('website_id', e.query.website_id || '')
        },
        immediate: true
      }
    },
    created() {
      this.$store.state.minHeight = document.documentElement.clientHeight - 286 + 'px'
      // console.log(this.$store.state.minHeight);
      // this.checkPlatform()
    },
    updated() {
      this.$nextTick(() => {
        window.scrollTo(0,0)
      })
    },
    mounted() {

      this.getParams()
    },
    methods: {
      getParams() {
        this.setTimer()
      },
      setTimer() {
        if (this.num === 20) return
        let website_id = localStorage.getItem('website_id')
        if (!website_id) {
          setTimeout(() => {
            this.setTimer()
            this.num += 1
          }, 10)
        } else {
          this.$api.get('/api/H5/website/get_detail').then(res => {
            document.title = res.data.name
            if(res.data.icon){
              this.changeFavicon(res.data.icon);
            }
          })
          this.$api.get('/api/h5_index_temp/check_diy').then(res => {
            if(res.data.web_status){
              this.checkPlatform()
            }
          })

          let params = {
            page_type: 'top'
          }
          this.$api.get('/api/H5/website/pc_temp', {
            params: params
          }).then(res => {
            let info = res.data.data
            res.data.seo && res.data.seo.title ? document.title = res.data.seo.title : ''
            document.getElementsByName('keywords')[0].content = res.data.seo.keywords
            document.getElementsByName('description')[0].content = res.data.seo.description
            if (info.themeStyle) {
              this.themeColor = info.themeStyle.color
              this.themeBgColor = info.themeStyle.backgroundColor
              this.backgroundImage = this.backgroundImage ? `url(${info.themeStyle.backgroundImage})` : this.backgroundImage
              this.cover = info.themeStyle.cover ? 'cover' : ''
              this.navColor = info.themeStyle.navColor
              this.detailBgcolor = info.themeStyle.detailBgcolor
            }
            if (info.style) {
              this.styleColor = info.style.color
              this.styleBgColor = info.style.backgroundColor
            }
            if (info.hoverStyle) {
              this.hoverStyle = info.hoverStyle.color
              this.hoverStyleBgColor = info.hoverStyle.backgroundColor
            }
          })
        }
        if(localStorage.getItem('website_id')=='32'){
          if (window.screen.width > 1000) {
          } else {
            let dom = document.getElementsByClassName('container')
            for(var i=0;i<dom.length;i++){
              dom[i].style.minWidth = 'unset'
            }
          }
        }
      },
      // 动态修改网站图标
      changeFavicon(link) {
        let $favicon = document.querySelector('link[rel="icon"]');
        if ($favicon !== null) {
          $favicon.href = link;
        } else {
          $favicon = document.createElement("link");
          $favicon.rel = "icon";
          $favicon.href = link;
          document.head.appendChild($favicon);
        }
      },
      geturlparam(name){
      	let search = window.location.search.substr(1) || window.location.hash.split("?")[1] || '';
      	  let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      	  let r = search.match(reg);
      	  if (r != null) return  unescape(r[2]);
      	  return null;
      },
      checkPlatform() {
        if ((navigator.userAgent.match(
            /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i))) {
          console.log('手机访问')
          let website_id = this.geturlparam('website_id')
          let url = window.location.origin + '/web/mobile_website_template/#/?website_id=' + website_id
          window.location.replace(url)
        } else {
          console.log('电脑访问')
        }


      }
    }
  }
</script>
<style lang="less">
  @font-face {
    font-family: 'mountain-font';
    src: url('https://cdn.rockysports.cn/mffont.ttf');
  }
  @media screen and (min-width: 1100px) {
    .container {
      width: 100%;
      min-width: 1260px;
      position: relative;
      overflow-x: hidden;
      background: var(--backgroundImage);
      background-size: var(--cover);
    }

    .w1250 {
      width: 1250px;
      position: relative;
    }

    .color-default {
      color: #221815;
    }

    .bg-white {
      background-color: #ffffff;
    }

    .flex-row {
      display: flex;
      flex-direction: row;
    }

    .flex-column {
      display: flex;
      flex-direction: column;
    }

    .align-center {
      align-items: center;
    }

    .justify-center {
      justify-content: center;
    }

    .flex-between {
      justify-content: space-between;
    }

    .page-block {
      // margin-bottom: 60px;
    }

    .w1250 {
      .el-breadcrumb {
        margin-top: 62px;
        margin-bottom: 0;
        padding: 24px 46px;
        // background-color: #3c3992;
        font-size: 22px;
        color: #0F1235;
        ;
        border-bottom: 1px solid #a9abcf;
      }

      // .el-breadcrumb__separator[class*=icon]{
      //   color: #c0c4cc;
      // }
      .el-breadcrumb__item:last-child .el-breadcrumb__inner,
      .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
      .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
      .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
        color: var(--nav-color, #D20E69);
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active,
      .el-pager li.active {
        background-color: #242263;
      }
    }



  }

  @media screen and (max-width: 1100px) {
    .container {
      width: 100%;
      min-width: 1260px;
      position: relative;
      overflow-x: hidden;
      background: var(--backgroundImage);
      background-size: var(--cover);
    }

    .w1250 {
      // width: 1250px;
      position: relative;
    }

    .color-default {
      color: #221815;
    }

    .bg-white {
      background-color: #ffffff;
    }

    .flex-row {
      display: flex;
      flex-direction: row;
    }

    .flex-column {
      display: flex;
      flex-direction: column;
    }

    .align-center {
      align-items: center;
    }

    .justify-center {
      justify-content: center;
    }

    .flex-between {
      justify-content: space-between;
    }

    .page-block {
      // margin-bottom: 60px;
    }

    .w1250 {
      .el-breadcrumb {
        margin-top: 62px;
        margin-bottom: 0;
        padding: 24px 46px;
        // background-color: #3c3992;
        font-size: 22px;
        color: #0F1235;
        ;
        border-bottom: 1px solid #a9abcf;
      }

      // .el-breadcrumb__separator[class*=icon]{
      //   color: #c0c4cc;
      // }
      .el-breadcrumb__item:last-child .el-breadcrumb__inner,
      .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
      .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
      .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
        color: var(--nav-color, #D20E69);
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active,
      .el-pager li.active {
        background-color: #242263;
      }
    }




    .container {
      width: 100%;
      position: relative;
      overflow-x: hidden;
      background: var(--backgroundImage);
      background-size: var(--cover);
    }
    .w1250 {
      width: 100%;
      position: relative;
    }


  }









</style>



// WEBPACK FOOTER //
// src/App.vue